import { Node } from "../../graph/lib/node";

/**
 * The abstract class MultiSetTreeNode extends the abstract class Node 
 * and describes the logical representation of a node in a tree.
 */
export abstract class MultiSetTreeNode extends Node {
    //Reference to the parent treenode
    protected parent: MultiSetTreeNode;

    //COntent of the node
    protected content: any[];

    //Not being used, but maybe in the future? Idea: Store fakecontent for exercises
    protected fakeContent: any[];
    protected totalCount: number = 0;
    protected hideContent: boolean = false;
    protected textMaxWidthCol: number = 100;;
    protected noBox: boolean = false;
    //color

    protected selectColor: string = "blue";
    protected standardColor: string = "black";
    protected currentColor: string = this.standardColor;


    constructor(rowIndex: number, colIndex: number,
        id: number, content: any[], totalCount: number) {
        super(rowIndex, colIndex, id);
        this.totalCount = totalCount;
        this.content = content;
    }

    addChildren(child: MultiSetTreeNode){
        this.addNeighbor(child);
    }

    getContent(): any[]{
        return this.content;
    }

    getFakeContent(): any[]{
        return this.fakeContent;
    }

    setFakeContent(fakeContent: any[]){
        this.fakeContent = fakeContent;
    }

    isHidden():boolean{
        return this.hideContent;
    }

    setHidden(hidden: boolean){
        this.hideContent = hidden;
    }

    setMaxTextWidth(maxWidthInCols: number){
        this.textMaxWidthCol = maxWidthInCols;
    }

    setNoBox(enable: boolean){
        this.noBox = enable;
    }

    getNoBox():boolean{
        return this.noBox;
    }

    resetColor(){
        this.currentColor = this.standardColor;
    }

    selected(){
        this.currentColor = this.selectColor;
    }

    isSelected(): boolean{
        return this.currentColor == this.selectColor;
    }

    


}
